import { useState } from "react";

export default function useLargeScreen() {
  const [onLargeScreen, setOnLargeScreen] = useState(window.innerWidth >= 1024);
  window.addEventListener("resize", () => {
    setOnLargeScreen(window.innerWidth >= 1024);
    // let x = window.matchMedia("(min-width: 1024px)");
    // console.log("on large screen:", x.matches, window.innerWidth >= 1024);
  });

  return onLargeScreen;
}
